import React, { Component } from 'react'

class CreateSuccess extends Component {
    render() {
        return (
            <div>
                <div class="success">
                    You have successfully created your new account!
                    <div>Check your email for your a welcome message we've sent to you.  This email will contain your new password.</div>
                </div>
                <br />
                    
                <div>If you do not see the email, please check your junk mail!</div>
            </div>
        )
    }
}

export default CreateSuccess



// WEBPACK FOOTER //
// ./src/components/customer/create/CreateSuccess.js